export default __webpack_public_path__ + "static/media/facility_02_3.91718ec6.png";